<template>
  <gd-modal
    name="share-post-modal"
    ref="share-post-modal"
    :title="$t('frontend_grooveblog_share_post')"

  >
    <div class="flex flex-col px-8 py-5">
      <div class="flex flex-col w-full mb-4">
        <label class="text-grey-dark mb-2">Select Blog</label>
        <gd-dropdown
          :options="blogList"
          class="w-full h-10 selectbox"
          v-model="postShare.selectedBlog"
          :maxHeight="'70px'"
          @change="getCategories"
        ></gd-dropdown>
      </div>
      <div class="w-full error text-primary-dark mt-1 text-sm" v-if="blogMessage">
        Blog is required
      </div>
      <div class="flex flex-col w-full mb-4">
        <label class="text-grey-dark mb-2">Select Category</label>
        <gd-dropdown
          :options="categoryList"
          class="w-full h-10 selectbox"
          :maxHeight="'70px'"
          v-model="postShare.selectedCategory"
        ></gd-dropdown>
      </div>
      <div
        class="w-full error text-primary-dark mt-1 text-sm"
        v-if="categoryMessage"
      >
        Category is required
      </div>
      <div class="flex flex-row w-full justify-center">
        <gd-button
          class="text-center h-10 border-grey-1 mr-4"
          size="large"
          v-on:click="shareCloseModal"
          >{{ $t('frontend_cancel') }}</gd-button
        >
        <gd-button
          class="text-center h-10"
          size="large"
          primary
          v-on:click="sharePost"
          >{{ $t('frontend_done') }}</gd-button
        >
      </div>
    </div>
  </gd-modal>
</template>
<script>
import axios from 'axios';
import {
  required,
  minLength,
  maxLength,
  alphaNum,
} from 'vuelidate/lib/validators';
import Loader from '@groovepages/gd-ui-kit/components/Loader';

export default {
  name: 'share',
  middleware: 'auth',
  // layout: 'defaultWithoutSidebar',
  components: {
    Loader,
  },
  data() {
    return {
      loading: true,
      categoryMessage: false,
      blogMessage: false,
      selectedBlog: '',
      blogList: [],
      categoryList: [],
      postShare: {
        selectedCategory: '',
        selectedBlog: '',
      },
    };
  },
  validations: {
    postShare: {
      selectedBlog: {
        required,
      },
      selectedCategory: {
        required,
      },
    },
  },
  computed: {},
  mounted() {
    console.log(this.$refs);
    this.$refs['share-post-modal'].open();
    this.loading = false;
    this.getBlog();
  },
  methods: {
    shareCloseModal() {},
    async sharePost() {
      this.$v.postShare.$touch();

      if (!this.$v.postShare.$invalid) {
        this.$v.postShare.$reset();
        this.showLoader();
        axios
          .post(`/blogpost/${this.$route.params.id}/share`,{blog_id : this.postShare.selectedBlog ,category_id :this.postShare.selectedCategory})
          .then((response) => {
            localStorage.setItem('blog-id', response.data.data.blog_id);
            this.$root.$emit('modal-close', 'share-post-modal');
            this.$router.push({ name: 'list_post' });
            this.hideLoader();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        if (this.postShare.selectedBlog == '') {
          this.blogMessage = true;
        }
        if (this.postShare.selectedCategory == '') {
          this.categoryMessage = true;
        }
      }
    },
    async getBlog() {
      this.showLoader();

      await axios
        // .post('/blog/search', this.searchBlogName)
        .get('/blogs')
        .then((response) => {
          let blogRes = response.data.data;
          for (var i = 0; i < blogRes.length; i++) {
            this.blogList.push({
              id: blogRes[i]['id'],
              text: blogRes[i]['name'],
              value: blogRes[i]['id'],
            });
          }

          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getCategories() {
      this.showLoader();
      this.blogMessage = false;
      this.categoryList = [];
      await axios
        .get('/categories?blog_id=' + this.postShare.selectedBlog)
        .then((response) => {
          let categoriesRes = response.data;
          for (var i = 0; i < categoriesRes.length; i++) {
            this.categoryList.push({
              id: categoriesRes[i]['id'],
              text: categoriesRes[i]['name'],
              value: categoriesRes[i]['id'],
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.hideLoader();
    },
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style lang="scss">
.share-blog-page {
  .fixed.inset-0.w-full.h-full.opacity-50.bg-white {
    opacity: 0.92 !important;
    background-color: grey !important;
  }
}
</style>
